var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotificationProfileNormalstate(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 20,
    viewBox: "0 0 17 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9451 6.35775C13.9451 4.93679 13.3662 3.57402 12.3356 2.56925C11.3051 1.56448 9.90737 1 8.44997 1C6.99257 1 5.59487 1.56448 4.56433 2.56925C3.53379 3.57402 2.95484 4.93679 2.95484 6.35775C2.95484 8.69835 2.56959 10.4129 2.08761 11.6421C1.72422 12.5688 2.58521 14.3944 3.58064 14.3944H13.3193C14.3147 14.3944 15.1757 12.5688 14.8123 11.6421C14.3304 10.4129 13.9451 8.69835 13.9451 6.35775Z",
    stroke: "#747474",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2319 16.2181C11.2319 17.7636 9.99551 19 8.45 19C6.90449 19 5.66809 17.7636 5.66809 16.2181H11.2319Z",
    stroke: "#747474",
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationProfileNormalstate);
export default __webpack_public_path__ + "static/media/Notification _ Profile _ normal state.6e45b87c7782b2537e18c1e9f605472c.svg";
export { ForwardRef as ReactComponent };